require('es6-promise').polyfill();
require('./bootstrap');
require('./sentry');
require('./valassis.js');

//import PersonalShopper from './components/personal-shopper/PersonalShopper';
import Vue from 'vue';
import Vuex from 'vuex';
import Cart from './components/ecommerce/cart/Cart.vue';
import CartIcon from '../../../shared/components/CartIcon.vue';
import CategoryFilters from './components/categories/CategoryFilters.vue';
import Checkout from './components/ecommerce/checkout/Checkout.vue';
import Location from './components/ecommerce/checkout/Location.vue';
import ListProduct from './components/product/ListProduct.vue';
import RssFeed from './components/RssFeed.vue';
import Locations from './components/locations/Locations.vue';
import GoogleMap from './components/locations/GoogleMap.vue';
import MobileMenu from './components/categories/MobileMenu.vue';
import MobileListProduct from './components/product/MobileListProduct';
import Product from './components/product/Product.vue';
import ProductPricingTab from "../../../shared/components/ProductPricingTab";
import ScrollToHome from './components/navigation/ScrollToHome';
import Search from './components/search/Search';
import {Carousel, Slide} from 'vue-carousel';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        cartCount: 0
    },
    getters: {
        cartCount: (state, getters) => {
            return state.cartCount;
        }
    },
    mutations: {
        decrementCartCount(state) {
            state.cartCount--;
        },
        incrementCartCount(state) {
            state.cartCount++;
        },
        setCartCount(state, cartCount) {
            state.cartCount = cartCount;
        }
    }
});

new Vue({
    el: '#app',
    components: {Cart, CartIcon, CategoryFilters, Checkout, ListProduct, Locations, MobileMenu, MobileListProduct, Product, ProductPricingTab, ScrollToHome, Search, Carousel, Slide, Location, GoogleMap, RssFeed},
    store: store,
});
